import React from "react";
import Tag from "components/lib/Shared/Tag";

const BoMaxValue = ({
  value = 0,
  oldValue = null,
  isInManualUpdate = false,
}) => {
  // If in manual update and there's an old value different from the current value,
  // display both values to show the change
  const showChange =
    isInManualUpdate && oldValue !== null && Number(oldValue) !== Number(value);

  const currentValue = Number(value);
  const previousValue = Number(oldValue);
  const hasDecreased = showChange && previousValue > currentValue;
  const hasIncreased = showChange && previousValue < currentValue;

  return (
    <div>
      <div>
        <div className="mt-4">
          <div className="flex items-center">
            <h2 className="text-xs font-semibold">Max:</h2>
            <div className="px-4 text-xs">
              {showChange ? (
                <div className="flex items-center space-x-2">
                  <div className="flex items-center space-x-1">
                    <span className="text-gray-600 font-medium">Before:</span>
                    <Tag className="bg-orange-100 border-orange-300">{`${previousValue}%`}</Tag>
                  </div>
                  <span className="text-gray-400">→</span>
                  <div className="flex items-center space-x-1">
                    <span className="text-gray-600 font-medium">Now:</span>
                    <Tag
                      className={`${
                        hasDecreased
                          ? "bg-red-100 border-red-300 text-red-800"
                          : hasIncreased
                          ? "bg-green-100 border-green-300 text-green-800"
                          : ""
                      }`}
                    >{`${currentValue}%`}</Tag>
                  </div>
                  {hasDecreased && (
                    <span className="text-red-600 text-xs font-medium">
                      (↓ -{(previousValue - currentValue).toFixed(2)}%)
                    </span>
                  )}
                  {hasIncreased && (
                    <span className="text-green-600 text-xs font-medium">
                      (↑ +{(currentValue - previousValue).toFixed(2)}%)
                    </span>
                  )}
                </div>
              ) : (
                <Tag>{`${currentValue}%`}</Tag>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoMaxValue;
